export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    title: that.$l('table_label_storeName') || '商铺名称',
    field: 'storeName',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_importDate') || '导入日期',
    field: 'importDate',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_snapshotDate') || '库存记录日期',
    field: 'snapshotDate',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_sku') || 'SKU',
    field: 'sku',
    width: 250,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_skuEcom') || '电商SKU',
    field: 'sku_ecom',
    width: 250,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_fnsku') || 'FNSKU',
    field: 'fnsku',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_asin') || 'ASIN',
    field: 'asin',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_productName') || '产品名称',
    field: 'productName',
    width: 400,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_condition') || '产品条件',
    field: 'prodCondition',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_available') || '可用数量',
    field: 'available',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_pendingRemovalQuantity') || '即将移除数量',
    field: 'pendingRemovalQuantity',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_invAge0To90Days') || '90天以内库龄数量',
    field: 'invAge0To90Days',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_invAge91To180Days') || '91-180天库龄数量',
    field: 'invAge91To180Days',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_invAge181To270Days') || '181-270天库龄数量',
    field: 'invAge181To270Days',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_invAge271To365Days') || '271-365天库龄数量',
    field: 'invAge271To365Days',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_invAge365PlusDays') || '365天以上库龄数量',
    field: 'invAge365PlusDays',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_currency') || '货币',
    field: 'currency',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_qtyToBeChargedLtsf9Mo') || '过去9个月即将计费数量',
    field: 'qtyToBeChargedLtsf9Mo',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_projectedLtsf9Mo') || '过去9个月项目数量',
    field: 'projectedLtsf9Mo',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_qtyToBeChargedLtsf12Mo') || '过去12个月即将计费数量',
    field: 'qtyToBeChargedLtsf12Mo',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_estimatedLtsfNextCharge') || '下个周期即将计费',
    field: 'estimatedLtsfNextCharge',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_unitsShippedT7') || 'T7发货数量',
    field: 'unitsShippedT7',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_unitsShippedT30') || 'T30发货数量',
    field: 'unitsShippedT30',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_unitsShippedT60') || 'T60发货数量',
    field: 'unitsShippedT60',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_unitsShippedT90') || 'T90发货数量',
    field: 'unitsShippedT90',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_alert') || '注意',
    field: 'alert',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_yourPrice') || '你的价格',
    field: 'yourPrice',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_salesPrice') || '销售价格',
    field: 'salesPrice',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_lowestPriceNewPlusShipping') || '最近发货最低价',
    field: 'lowestPriceNewPlusShipping',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_lowestPriceUsed') || '历史最低价',
    field: 'lowestPriceUsed',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_recommendedAction') || '建议的行动',
    field: 'recommendedAction',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_healthyInventoryLevel') || '健康库存水平',
    field: 'healthyInventoryLevel',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_recommendedSalesPrice') || '推荐销售价格',
    field: 'recommendedSalesPrice',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_recommendedSaleDurationDays') || '推荐销售周期天数',
    field: 'recommendedSaleDurationDays',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_recommendedRemovalQuantity') || '建议移除数量',
    field: 'recommendedRemovalQuantity',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_estimatedCostSavingsOfRecommende') || '建议措施的估计成本节约',
    field: 'estimatedCostSavingsOfRecommendedActions',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_sellThrough') || '直销',
    field: 'sellThrough',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_itemVolume') || '体积',
    field: 'itemVolume',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_volumeUnitMeasurement') || '体积单位',
    field: 'volumeUnitMeasurement',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_storageType') || '存储类型',
    field: 'storageType',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_storageVolume') || '存储体积',
    field: 'storageVolume',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_marketplace') || '市场',
    field: 'marketplace',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_productGroup') || '产品组',
    field: 'productGroup',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_salesRank') || '销售排名',
    field: 'salesRank',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_daysOfSupply') || '可销售日期',
    field: 'daysOfSupply',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_estimatedExcessQuantity') || '估计超额数量',
    field: 'estimatedExcessQuantity',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_weeksOfCoverT30') || '承保周数T30',
    field: 'weeksOfCoverT30',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_weeksOfCoverT90') || '承保周数T90',
    field: 'weeksOfCoverT90',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_featuredofferPrice') || '特征价格',
    field: 'featuredofferPrice',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_salesShippedLast7Days') || '最近7天发货的销售额',
    field: 'salesShippedLast7Days',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_salesShippedLast30Days') || '最近30天发货的销售额',
    field: 'salesShippedLast30Days',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_salesShippedLast60Days') || '最近60天发货的销售额',
    field: 'salesShippedLast60Days',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_salesShippedLast90Days') || '最近90天发货的销售额',
    field: 'salesShippedLast90Days',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_invAge0To30Days') || '库龄0-30天数量',
    field: 'invAge0To30Days',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_invAge31To60Days') || '库龄31-60天数量',
    field: 'invAge31To60Days',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_invAge61To90Days') || '库龄61-90天数量',
    field: 'invAge61To90Days',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_invAge181To330Days') || '库龄181-330天数量',
    field: 'invAge181To330Days',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_invAge331To365Days') || '库龄331-365天数量',
    field: 'invAge331To365Days',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_estimatedStorageCostNextMonth') || '下个月预计存储成本',
    field: 'estimatedStorageCostNextMonth',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_inboundQuantity') || '入库数量',
    field: 'inboundQuantity',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_inboundWorking') || '入库工作',
    field: 'inboundWorking',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_inboundShipped') || '入库发货',
    field: 'inboundShipped',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_inboundReceived') || '入库已接收',
    field: 'inboundReceived',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_noSaleLast6Months') || '过去6个月没有销售',
    field: 'noSaleLast6Months',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_reservedQuantity') || '保留数量',
    field: 'reservedQuantity',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_unfulfillableQuantity') || '不可实现数量',
    field: 'unfulfillableQuantity',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_creationTime') || '记录创建时间',
    field: 'creationTime',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_updatedTime') || '修改时间',
    field: 'updatedTime',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
